import { useQueryClient } from '@tanstack/react-query';
import { NotificationManager } from 'react-notifications';
import { useApiMutation } from '@/hooks/api/useApiMutation';
import { queryKeys } from '@/queries/query-keys';
import { useAuthStore } from '@/stores/auth-store';

/**
 * POST `/org` (i.e. `{API_BASE_URL}/org`, typically `…/api/org`) — creates org + admin account,
 * sets session cookie, returns {@link Account}.
 */
export function useCreateOrgMutation() {
  const queryClient = useQueryClient();

  return useApiMutation(
    () => '/org',
    'post',
    {},
    {
      onSuccess: (data) => {
        useAuthStore.getState().setSession(data);
        queryClient.invalidateQueries({ queryKey: queryKeys.session() });
        NotificationManager.success('Account created', '', 3000);
      },
      onError: (err) => {
        NotificationManager.error(
          err.message || 'Could not create account',
          '',
          4000,
        );
      },
    },
    (values) => ({
      accountName: values.accountName.trim(),
      password: values.password,
      orgName: values.orgName.trim(),
    }),
  );
}
